import { useRouter } from "next/router";
import { ArrowIcon } from "../../assets/icons/ArrowIcon";

interface Props {
  text?: string;
  fallbackUrl?: string;
  onBack?: () => void;
  className?: string;
}

export const BackButton = ({ text, fallbackUrl, onBack, className }: Props) => {
  const router = useRouter();
  const back = async () => {
    if (
      typeof window !== "undefined" &&
      Number(window?.history?.state?.idx) > 0
    ) {
      await router.back();
      if (onBack) onBack();
    } else {
      await router.replace(fallbackUrl || "/");
    }
  };

  return (
    <button
      type="button"
      tw="flex items-center p-4"
      onClick={back}
      className={className}
    >
      <ArrowIcon />
      {text && (
        <span tw="font-base text-base leading-4 text-theme tracking-[.8px] text-center ml-2">
          {text}
        </span>
      )}
    </button>
  );
};
